"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Trigger = exports.Separator = exports.Label = exports.Item = exports.Content = void 0;
var _react = _interopRequireDefault(require("react"));
var RadixDropdownMenu = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _button = require("../buttons/button.tokens");
var _tokens = _interopRequireDefault(require("../../../../forecast-v2/shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledContent = (0, _styledComponents.default)(RadixDropdownMenu.Content).withConfig({
  displayName: "DropdownHandler__StyledContent",
  componentId: "sc-e3it3q-0"
})(["min-width:210px;max-width:375px;background:#ffffff;box-shadow:0 4px 16px rgba(0,0,0,0.12);border-radius:0 0 ", " ", ";padding:12px 0 12px 0;z-index:49;"], _tokens.default.sky.sys.size.borderradius['3'], _tokens.default.sky.sys.size.borderradius['3']);
var StyledItem = (0, _styledComponents.default)(RadixDropdownMenu.Item).withConfig({
  displayName: "DropdownHandler__StyledItem",
  componentId: "sc-e3it3q-1"
})(["display:flex;flex-direction:row;align-items:center;min-height:20px;padding:6px 12px 6px 12px;margin-right:12px;margin-left:12px;cursor:pointer;border-radius:", ";border-width:2px 2px 2px 0;border-style:solid;border-color:transparent;", ";gap:16px;&:hover{background-color:", ";}&:focus{border-color:", ";outline:none;&:hover{border-color:transparent;}}"], _tokens.default.sky.sys.size.borderradius.focusring, _tokens.default.sky.sys.font.body['1'], _tokens.default.sky.sys.color.background.primary['1'], _tokens.default.sky.sys.color.border.active);
var StyledLabel = (0, _styledComponents.default)(RadixDropdownMenu.Label).withConfig({
  displayName: "DropdownHandler__StyledLabel",
  componentId: "sc-e3it3q-2"
})(["min-height:20px;padding:8px 12px 0 24px;font-family:Inter;font-size:16px;font-weight:600;line-height:24px;gap:16px;"]);
var StyledSeparator = (0, _styledComponents.default)(RadixDropdownMenu.Separator).withConfig({
  displayName: "DropdownHandler__StyledSeparator",
  componentId: "sc-e3it3q-3"
})(["height:1px;background-color:#d3d3df;margin-top:", ";margin-bottom:", ";"], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['300']);
var StyledTrigger = (0, _styledComponents.default)(RadixDropdownMenu.Trigger).withConfig({
  displayName: "DropdownHandler__StyledTrigger",
  componentId: "sc-e3it3q-4"
})(["&[data-state='open']{svg{path{fill:", ";}}}"], function (props) {
  return props.activeColor || (0, _button.buttonTokens)(props.theme).color.icon.low.default;
});
var DropdownHandler = function DropdownHandler(_ref) {
  var children = _ref.children,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    open = _ref.open;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixDropdownMenu.Root, {
    modal: false,
    defaultOpen: defaultOpen,
    open: open,
    children: children
  });
};
var Item = function Item(_ref2) {
  var children = _ref2.children,
    disabled = _ref2.disabled,
    onClick = _ref2.onClick,
    asChild = _ref2.asChild,
    dataCy = _ref2['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledItem, {
    disabled: disabled,
    onSelect: onClick,
    asChild: asChild,
    "data-cy": dataCy,
    children: children
  });
};
exports.Item = Item;
var Label = function Label(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
    children: children
  });
};
exports.Label = Label;
var Separator = function Separator() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSeparator, {});
};
exports.Separator = Separator;
Item.defaultProps = {
  disabled: false,
  onClick: function onClick() {},
  asChild: false
};
var Trigger = function Trigger(_ref4) {
  var children = _ref4.children,
    other = _objectWithoutProperties(_ref4, ["children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTrigger, _objectSpread({
    asChild: true
  }, other, {
    children: children
  }));
};
exports.Trigger = Trigger;
var Content = function Content(_ref5) {
  var children = _ref5.children,
    offset = _ref5.offset,
    align = _ref5.align,
    side = _ref5.side;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixDropdownMenu.Portal, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, {
      sideOffset: offset,
      align: align,
      side: side,
      children: children
    })
  });
};
exports.Content = Content;
Content.defaultProps = {
  offset: 0,
  align: 'end',
  side: 'bottom'
};

// ONLY USED FOR STORYBOOK DOCUMENTATION

DropdownHandler.Trigger = Trigger;
DropdownHandler.Content = Content;
DropdownHandler.Item = Item;
DropdownHandler.Label = Label;
DropdownHandler.Separator = Separator;
var _default = exports.default = DropdownHandler;